import { basicInitialState } from 'store/_utils/basicInitialState';
import { TFarmLicencesState } from './farmLicencesModel';

export const farmLicencesInitialState: TFarmLicencesState = {
  ...basicInitialState,
  licences: [],
  searchText: ''
};
